import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaSelectThemePage } from './plaza-select-theme';

@NgModule({
  declarations: [
    PlazaSelectThemePage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaSelectThemePage),
    TranslateModule.forChild()
  ],
})
export class PlazaSelectThemePageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-theme/plaza-select-theme.module.ts